import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@draeger-academy/common';
import { ResponsiveModule } from '@viablelogic/ngx-responsive';

import { DaProgressiveImageModule } from '../da-progressive-image/da-progressive-image.module';

import { VideoComponent } from './video.component';
@NgModule({
    declarations: [VideoComponent],
    exports: [VideoComponent],
    imports: [CommonModule, ResponsiveModule, DaProgressiveImageModule, PipesModule]
})
export class VideoModule {}
